module.exports = __webpack_public_path__ + "img/level-icon1.603d9c05.png";